// extracted by mini-css-extract-plugin
export default {"nameContainer":"nameEditor_nameContainer__nwg5I","label":"nameEditor_label__68DX5","customNameInput":"nameEditor_customNameInput__eVzWS"};